import Alpine from "alpinejs"

Alpine.data("heroHome", (slide_count, autoplay = true) => ({
    miliseconds: 0,
    duration: 20000,
    refreshrate: 300,
    playing: autoplay,
    slide: 0,
    slide_count,
    init() {
        this.interval = setInterval(() => this.refresh(), this.refreshrate)
    },
    refresh() {
        if (this.playing) {
            this.miliseconds = this.miliseconds + this.refreshrate
            if (this.miliseconds % this.duration === 0) {
                this.miliseconds += this.duration
                this.slide = (this.slide + 1) % this.slide_count
            }
        }
    },
    stop() {
        clearInterval(this.interval)
    },
    prev() {
        this.stop()
        this.miliseconds -= this.miliseconds % this.duration
        this.slide = (this.slide_count + this.slide - 1) % this.slide_count
    },
    next() {
        this.stop()
        this.miliseconds += 2 * this.duration - (this.miliseconds % this.duration)
        this.slide = (this.slide + 1) % this.slide_count
    },
}))
